import { useEffect, useState } from 'react';
import Logo from '../assets/Untitled design (1).svg';

interface LoadingScreenProps {
  showTagline?: boolean;
  shouldFadeOut?: boolean;
  onFadeComplete?: () => void;
}

export default function LoadingScreen({
  showTagline = true,
  shouldFadeOut = false,
  onFadeComplete
}: LoadingScreenProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, 50);

    return () => {
      clearTimeout(showTimer);
    };
  }, []);

  useEffect(() => {
    if (shouldFadeOut && onFadeComplete) {
      const fadeOutTimer = setTimeout(() => {
        onFadeComplete();
      }, 500);
      return () => clearTimeout(fadeOutTimer);
    }
  }, [shouldFadeOut, onFadeComplete]);

  return (
    <div
      className="fixed inset-0 z-[150] flex items-center justify-center bg-[#111111]"
      style={{
        opacity: shouldFadeOut ? 0 : (isVisible ? 1 : 0),
        transition: shouldFadeOut ? 'opacity 500ms ease-out' : 'opacity 200ms ease-in',
      }}
      aria-busy="true"
      aria-label="Loading"
    >
      <div className="flex flex-col items-center justify-center gap-6 px-6">
        <div
          className="relative flex items-center justify-center"
          style={{
            animation: 'pulse-subtle 2.5s ease-in-out infinite',
          }}
        >
          <div
            className="absolute inset-0 bg-brand-teal rounded-full blur-2xl opacity-5"
            style={{
              width: '406px',
              height: '406px',
            }}
          />

          <img
            src={Logo}
            alt="Civicbeat"
            className="relative w-[287px] md:w-[372px] h-auto select-none"
            draggable={false}
            style={{
              filter: 'drop-shadow(0 4px 12px rgba(64, 224, 208, 0.08))',
            }}
          />
        </div>

        {showTagline && (
          <p
            className="text-[12px] md:text-[13px] text-center max-w-sm"
            style={{
              color: 'rgba(160, 160, 160, 0.6)',
              opacity: 0,
              animation: 'fade-in-delayed 0.4s ease-out 0.3s forwards',
              letterSpacing: '0.02em',
              lineHeight: '1.5',
              fontWeight: 400,
            }}
          >
            Tuning in.
          </p>
        )}
      </div>

      <style>{`
        @keyframes pulse-subtle {
          0%, 100% {
            transform: scale(0.98);
            opacity: 0.95;
          }
          50% {
            transform: scale(1.02);
            opacity: 1;
          }
        }

        @keyframes fade-in-delayed {
          from {
            opacity: 0;
            transform: translateY(6px);
          }
          to {
            opacity: 0.6;
            transform: translateY(0);
          }
        }

        @media (prefers-reduced-motion: reduce) {
          [style*="animation"] {
            animation: none !important;
          }
        }
      `}</style>
    </div>
  );
}
